import { styled, TableHead as MuiTableHead, TableRow } from '@material-ui/core'

const TableHead = styled(MuiTableHead)(() => ({}))

export const TableRowHead = styled(TableRow)({})

export default TableHead
